// 19000 m = 1 tree
const oneMToTree = 0.000052; // tree

const getTreesFromMeters = (meters) => (meters * oneMToTree).toFixed(2);

export const getMetersFromTrees = (trees) => parseFloat((trees / oneMToTree).toFixed(2));

export default getTreesFromMeters;



// WEBPACK FOOTER //
// ./src/helpers/get-trees-from-meters.js